import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["href"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["href"]

import { Form } from 'vee-validate';
import { ref, computed } from 'vue';
import { scrollToError } from '@/js/lib/helper/validate';
import { signin, signup } from '@/js/lib/api/user';
import { checkEmailExistence } from '@/js/lib/api/validate';
import { useCommonStore } from '@/js/lib/store/common';
import { useUserStore } from '@/js/lib/store/user';
import { info, loading } from '@/js/lib/ui';
import IButton from '@/js/components/molecules/IButton.vue';
import ITextField from '@/js/components/molecules/ITextField.vue';

interface FormData {
  email: string;
  password: string;
  memberName: string;
  remember: boolean;
  mailmagazine: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SigninSignupForm',
  props: {
    modelValue: { default: '' },
    email: { default: '' },
    memberName: { default: '' },
    transactionToken: { default: '' },
    oauthProvider: { default: undefined },
    isModal: { type: Boolean },
    from: { default: '' }
  },
  emits: ["update:modelValue", "close", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const socialProviders = [
  {
    id: 'facebook',
    label: 'Facebook',
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path d="M48 24C48 10.7438 37.2562 0 24 0C10.7438 0 0 10.7438 0 24C0 35.9813 8.775 45.9094 20.25 47.7094V30.9375H14.1562V24H20.25V18.7125C20.25 12.6984 23.8313 9.375 29.3156 9.375C31.9406 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6594C28.6781 15.75 27.75 17.6016 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7094C39.225 45.9094 48 35.9813 48 24Z" fill="#1877F2"/><path d="M33.3422 30.9375L34.4062 24H27.75V19.5C27.75 17.6016 28.6781 15.75 31.6594 15.75H34.6875V9.84375C34.6875 9.84375 31.9406 9.375 29.3156 9.375C23.8313 9.375 20.25 12.6984 20.25 18.7125V24H14.1562V30.9375H20.25V47.7094C21.4734 47.9016 22.725 48 24 48C25.275 48 26.5266 47.9016 27.75 47.7094V30.9375H33.3422Z" fill="white"/></svg>',
  },
  {
    id: 'twitter',
    label: 'X',
    svg: '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 1200 1227"><path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="black"/></svg>',
  },
];
const { isWebView } = useCommonStore();
const userStore = useUserStore();
const formData = ref<FormData>({
  email: props.email,
  password: '',
  remember: true,
  memberName: props.memberName,
  mailmagazine: true,
});
const isSignin = computed(() => props.modelValue === 'signin');
const pageTitle = computed(() => (isSignin.value ? 'ログイン' : '会員登録'));
const connectArr = computed(() =>
  socialProviders.map((item) => {
    const from = props.from ? `?from=${props.from}` : '';
    const url = `/${props.modelValue}/with/${item.id}${from}`;
    return {
      id: item.id,
      label: item.label,
      svg: item.svg,
      url,
    };
  }),
);
const helpLink = computed(() => (isSignin.value ? 'https://help.iichi.com/hc/ja/articles/360000013721' : 'https://help.iichi.com/hc/ja/articles/200196409'));
const socialProvider = computed(() => (provider) => socialProviders.find((p) => p.id === provider));
const onSubmit = async (_values, { setFieldError }) => {
  const emailExistence = await checkEmailExistence({ email: formData.value.email });
  if (!isSignin.value && emailExistence !== true) {
    setFieldError('メールアドレス', emailExistence);
    scrollToError();
    return;
  }
  loading({
    asyncFunc: async () => {
      if (isSignin.value) {
        const res = await signin({
          email: formData.value.email,
          password: formData.value.password,
          remember: formData.value.remember,
        });
        if (res.error === false) {
          userStore.setSignined();
          if (props.isModal) {
            emit('submit', props.modelValue);
          } else {
            window.location.href = props.from || '/';
          }
        } else {
          info('メールアドレス、もしくはパスワードが違います。', { fadeOut: true });
        }
      } else {
        await signup({
          email: formData.value.email,
          password: formData.value.password,
          memberName: formData.value.memberName,
          subscribeNewsletter: formData.value.mailmagazine,
          transactionToken: props.transactionToken,
        });
        userStore.setSignined();
        if (props.isModal) {
          emit('submit', props.modelValue);
        } else {
          window.location.href = props.from || '/';
        }
      }
    },
  });
};
const onClick = (name: string, $event) => {
  if (props.isModal) {
    emit('update:modelValue', name);
  } else {
    window.location.href = $event.target.href;
  }
};
const close = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.container, _ctx.isModal && _ctx.$style.containerInModal])
    }, [
      (_ctx.isModal)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(_ctx.$style.backLink)
          }, [
            _createElementVNode("button", {
              onClick: _withModifiers(close, ["prevent"])
            }, "< 戻る")
          ], 2))
        : _createCommentVNode("", true),
      _cache[27] || (_cache[27] = _createTextVNode()),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.content)
      }, [
        (isSignin.value)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(_ctx.$style.signup)
            }, [
              _createElementVNode("a", {
                href: `/signup?from=${_ctx.from}`,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (onClick('signup', $event)), ["prevent"]))
              }, "会員登録はこちら", 8, _hoisted_1)
            ], 2))
          : (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: _normalizeClass(_ctx.$style.signup)
            }, [
              _createElementVNode("a", {
                href: `/signin?from=${_ctx.from}`,
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (onClick('signin', $event)), ["prevent"]))
              }, "ログインはこちら", 8, _hoisted_2)
            ], 2)),
        _cache[24] || (_cache[24] = _createTextVNode()),
        _createElementVNode("h1", {
          class: _normalizeClass(_ctx.$style.pageTitle)
        }, _toDisplayString(pageTitle.value), 3),
        _cache[25] || (_cache[25] = _createTextVNode()),
        (_ctx.oauthProvider && socialProvider.value(_ctx.oauthProvider))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(_ctx.$style.socialConnected)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.socialConnectedSvg),
                innerHTML: socialProvider.value(_ctx.oauthProvider).svg
              }, null, 10, _hoisted_3),
              _cache[7] || (_cache[7] = _createTextVNode()),
              _createElementVNode("div", null, _toDisplayString(socialProvider.value(_ctx.oauthProvider).label) + "連携しています", 1)
            ], 2))
          : _createCommentVNode("", true),
        _cache[26] || (_cache[26] = _createTextVNode()),
        _createVNode(_unref(Form), {
          onInvalidSubmit: _unref(scrollToError),
          onSubmit: onSubmit
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", {
              class: _normalizeClass(_ctx.$style.formInner)
            }, [
              _createElementVNode("li", null, [
                _createVNode(ITextField, {
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                  modelModifiers: { trim: true },
                  name: "メールアドレス",
                  title: "メールアドレス",
                  type: "email",
                  autocomplete: "email",
                  rules: "required|email|max:200"
                }, null, 8, ["modelValue"])
              ]),
              _cache[8] || (_cache[8] = _createTextVNode()),
              _createElementVNode("li", null, [
                _createVNode(ITextField, {
                  modelValue: formData.value.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.password) = $event)),
                  modelModifiers: { trim: true },
                  name: "パスワード",
                  title: "パスワード",
                  type: "password",
                  autocomplete: isSignin.value ? 'current-password' : 'new-password',
                  rules: "required|min:8|max:16|alpha_num"
                }, null, 8, ["modelValue", "autocomplete"])
              ]),
              _cache[9] || (_cache[9] = _createTextVNode()),
              (!isSignin.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                    _createVNode(ITextField, {
                      modelValue: formData.value.memberName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.memberName) = $event)),
                      modelModifiers: { trim: true },
                      name: "ユーザー名",
                      title: "ユーザー名",
                      autocomplete: "username",
                      rules: "required|max:32|member_name"
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _cache[20] || (_cache[20] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.remember)
              }, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.remember) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.remember]
                  ]),
                  _cache[10] || (_cache[10] = _createTextVNode(" 設定を保存"))
                ])
              ], 2),
              _cache[12] || (_cache[12] = _createTextVNode()),
              _createVNode(IButton, {
                type: "primary",
                "native-type": "submit",
                class: _normalizeClass(_ctx.$style.loginBtn)
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("ログインする")
                ])),
                _: 1
              }, 8, ["class"]),
              _cache[13] || (_cache[13] = _createTextVNode()),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.$style.forget)
              }, [
                _createElementVNode("a", {
                  href: "/signin/forget/password",
                  class: _normalizeClass(_ctx.$style.forgetLink)
                }, "パスワードをお忘れの方", 2)
              ], 2)
            ], 512), [
              [_vShow, isSignin.value]
            ]),
            _cache[21] || (_cache[21] = _createTextVNode()),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.mailmagazine)
              }, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.mailmagazine) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, formData.value.mailmagazine]
                  ]),
                  _cache[14] || (_cache[14] = _createTextVNode(" メールマガジンを購読する"))
                ]),
                _cache[16] || (_cache[16] = _createTextVNode()),
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.$style.note)
                }, _cache[15] || (_cache[15] = [
                  _createTextVNode("\n                会員登録には、"),
                  _createElementVNode("a", {
                    href: "/rule",
                    target: "_blank",
                    class: "text-decoration-underline"
                  }, "利用規約", -1),
                  _createTextVNode("と"),
                  _createElementVNode("a", {
                    href: "/privacy",
                    target: "_blank",
                    class: "text-decoration-underline"
                  }, "プライバシーポリシー", -1),
                  _createTextVNode("への同意が必要です。\n              ")
                ]), 2)
              ], 2),
              _cache[18] || (_cache[18] = _createTextVNode()),
              _createVNode(IButton, {
                type: "primary",
                "native-type": "submit",
                class: _normalizeClass(_ctx.$style.loginBtn)
              }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("同意して会員登録する")
                ])),
                _: 1
              }, 8, ["class"])
            ], 512), [
              [_vShow, !isSignin.value]
            ]),
            _cache[22] || (_cache[22] = _createTextVNode()),
            (!_unref(isWebView) && _ctx.oauthProvider === undefined)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(_ctx.$style.or)
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.$style.orInner)
                    }, "または", 2)
                  ], 2),
                  _cache[19] || (_cache[19] = _createTextVNode()),
                  _createElementVNode("ul", {
                    class: _normalizeClass(_ctx.$style.socialBtns)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(connectArr.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.id,
                        class: _normalizeClass(_ctx.$style.socialBtn)
                      }, [
                        _createElementVNode("a", {
                          href: item.url,
                          class: _normalizeClass(_ctx.$style.socialBtnLink)
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(_ctx.$style.socialBtnSvg)
                          }, [
                            _createElementVNode("span", {
                              innerHTML: item.svg
                            }, null, 8, _hoisted_6)
                          ], 2),
                          _createTextVNode(_toDisplayString(item.label) + "で" + _toDisplayString(isSignin.value ? 'ログイン' : '登録'), 1)
                        ], 10, _hoisted_5)
                      ], 2))
                    }), 128))
                  ], 2)
                ], 64))
              : _createCommentVNode("", true),
            _cache[23] || (_cache[23] = _createTextVNode()),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                href: helpLink.value,
                target: "_blank"
              }, _toDisplayString(pageTitle.value) + "でお困りの方", 9, _hoisted_7)
            ])
          ]),
          _: 1
        }, 8, ["onInvalidSubmit"])
      ], 2)
    ], 2)
  ], 2))
}
}

})